module.exports = __webpack_public_path__ + "img/nft.b5a41935.gif";